export default __webpack_public_path__ + "static/media/ai-write-1.c9872fac.webp";